import { Button, ContentCard } from "@narmi/design_system";
import { Localized } from "@fluent/react";
import { memo } from "react";

import type { ChartStaticData } from "../types";
import styles from "./DemoChartOverlay.module.scss";
import useAoiobLink from "../../../dashboard/hooks/useAoiobLink";

type DemoStaticData = Extract<
  ChartStaticData,
  "demo_no_accounts" | "demo_no_transactions"
>;

const ID_PREFIX: Record<DemoStaticData, string> = {
  demo_no_transactions: "dashboard-demo-chart-overlay",
  demo_no_accounts: "dashboard-demo-chart-overlay-no-accounts"
} as const;

type DemoChartOverlayProps = {
  staticData: DemoStaticData;
};

const DemoChartOverlay = ({ staticData }: DemoChartOverlayProps) => {
  const onClick = useAoiobLink();

  const prefix = ID_PREFIX[staticData];

  const goToTransferPage = () => {
    window.location.assign("/transfer");
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <ContentCard kind="elevated">
          <div className={styles.cardContent}>
            <h4>
              <Localized id={`${prefix}-heading`} />
            </h4>
            <p>
              <Localized id={`${prefix}-description`} />
            </p>
            <div>
              <Button
                onClick={
                  staticData === "demo_no_transactions"
                    ? goToTransferPage
                    : onClick
                }
              >
                <Localized id={`${prefix}-cta`} />
              </Button>
            </div>
          </div>
        </ContentCard>
      </div>
    </div>
  );
};

export default memo(DemoChartOverlay);
